module.exports = __webpack_public_path__ + "img/minibox.a5a4f388.png";